import { ClickAwayListener, Paper, Popper, Typography, Button, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import CustomDivider from "../../CustomDivider";
import AppleLogo from "./assets/AppleLogo";
import PlayStoreIcon from "./assets/PlayStoreIcon";
import CustomModal from "../../modal";
import { CustomStackFullWidth } from "../../../styled-components/CustomStyles.style";
import CloseIcon from "@mui/icons-material/Close";

const ItemWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	padding: "12px",
	position: "relative",
	gap: "10px",
	cursor: "pointer",
}));

const Item = ({ image, title, link, t, platform }) => {
	const [hover, setHover] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);
	const [modalContent, setModalContent] = useState({ title: "", message: "", url: "" });
	
	const handleDownload = (url, platform) => {
		if (!url) {
			toast.error(t("No Redirect Url found"));
			return;
		}
		
		if (platform === "android") {
			if (url.includes(".apk")) {
				// Direct download for APK
				window.open(url);
			} else {
				// Show coming soon modal for Play Store
				setModalContent({
					title: t("Coming Soon"),
					message: t("This app will be available on Play Store soon. You can download it directly from the link below."),
					url: url
				});
				setModalOpen(true);
			}
		} else if (platform === "ios") {
			// Check if URL is blank or generic Apple App Store URL
			if (!url || url === "https://www.apple.com/app-store/") {
				// Show coming soon modal with no download option
				setModalContent({
					title: t("Coming Soon"),
					message: t("This app will be available on App Store soon."),
					url: ""
				});
				setModalOpen(true);
			} else {
				// Show coming soon modal with download option for other URLs
				setModalContent({
					title: t("Coming Soon"),
					message: t("This app will be available on App Store soon. You can access it from the link below."),
					url: url
				});
				setModalOpen(true);
			}
		}
	};
	
	const handleModalClose = () => {
		setModalOpen(false);
		setModalContent({ title: "", message: "", url: "" });
	};
	
	const handleClick = () => {
		handleDownload(link, platform);
	};
	return (
			<>
				<ItemWrapper
					onMouseEnter={() => setHover(true)}
					onMouseLeave={() => setHover(false)}
					onClick={handleClick}
				>
					{image}
					<Typography color={hover ? "primary" : "text.secondary"}>
						{title}
					</Typography>
				</ItemWrapper>
				<CustomModal
					open={modalOpen}
					onClose={handleModalClose}
					maxWidth="sm"
				>
					<Box sx={{ p: 3, position: "relative" }}>
						<IconButton
							aria-label="close"
							onClick={handleModalClose}
							sx={{
								position: "absolute",
								right: 8,
								top: 8,
								color: (theme) => theme.palette.grey[500],
							}}
						>
							<CloseIcon />
						</IconButton>
						<CustomStackFullWidth spacing={2} alignItems="center">
							<Typography variant="h6" component="h2">
								{modalContent.title}
							</Typography>
							<Typography variant="body1" color="text.secondary">
								{modalContent.message}
							</Typography>
							{modalContent.url && (
								<Button
									variant="contained"
									color="primary"
									onClick={() => {
										window.open(modalContent.url);
										handleModalClose();
									}}
									sx={{ mt: 1 }}
								>
									{t("Download Now")}
								</Button>
							)}
						</CustomStackFullWidth>
					</Box>
				</CustomModal>
			</>
		);
};
const CustomPopover = (props) => {
	const { width,openPopover, handleClose,anchorEl, t, urls } = props;
	return (
		<ClickAwayListener onClickAway={handleClose}>
			<Popper
				open={openPopover}
				anchorEl={anchorEl}
				placement="bottom"
				onClose={handleClose}
				disablePortal={false}
				modifiers={{
					flip: {
						enabled: false,
					},
					preventOverflow: {
						enabled: true,
						boundariesElement: "scrollParent",
					},
				}}
			>
				<Paper sx={{ 
					marginTop: "6px", 
					width: width,
					backgroundColor: (theme) => theme.palette.background.paper,
					color: (theme) => theme.palette.text.primary,
				}}>
					{urls?.playStoreStatus === "1" && (
						<Item
							image={<PlayStoreIcon />}
							title={t("Google Play")}
							link={urls?.playStoreUrl}
							t={t}
							platform="android"
						/>
					)}
					{urls?.playStoreStatus === "1" &&
					urls?.appStoreStatus === "1" ? (
						<CustomDivider />
					) : null}
					{urls?.appStoreStatus === "1" && (
						<Item
							image={<AppleLogo />}
							title={t("App Store")}
							link={urls?.appStoreUrl}
							t={t}
							platform="ios"
						/>
					)}
				</Paper>
			</Popper>
		</ClickAwayListener>
	);
};

CustomPopover.propTypes = {};

export default CustomPopover;
